import {SetStyle} from '../set-style';

export class SetBgImage extends SetStyle {
    static historyName = 'Changed background image';
}
